import axiApi from "ApiCaller";
// Estado del contenedor (waste.status) que permite evaluarlo. Mismo valor que ContainerStatus.ACTIVE del backend.
export const CONTAINER_STATUS_ACTIVE = "ac";
// Solo se evalúan (C1/C2/C3) los assets activos con el contenedor en estado activo.
export const isEvaluated = (asset) => asset.active && asset.status === CONTAINER_STATUS_ACTIVE;

// Leyenda de cada criterio del punto 5 (title de las cabeceras de las tablas)
export const CRITERIA_TITLES = {
    c1: "C1: nivel actual por encima del umbral de riesgo",
    c2: "C2: nivel previsto al final de la ruta por encima del umbral objetivo",
    c3: "C3: riesgo de superar el umbral en la próxima ruta si no se recoge hoy",
    c4: "C4: sin comunicar más de las horas de C4 y nivel por encima de su umbral",
    c5: "C5: sin comunicar más de las horas de C5 y nivel por encima de su umbral",
    c6: "C6: sin comunicar más de las horas de C6 y nivel por encima de su umbral",
};

export const LIMIT_ASSETS_MAPS = {
    AZURE: 150,
    GOOGLE: 150,
    OSRM: 100,
};
export const TotalsModel = {
    duration: "",
    used: "",
    steps: "",
    minutes: {
        assign: 0,
        used: 0,
        steps: 0,
    },
    average: 0,
    containers: 0,
    comply: 0,
    dont: 0,
    refused: 0,
    included: 0,
    routed: 0,
    errorCalculated: false,
    action: "",
};

export const ContextModel = function () {
    return {
        travel_: null, // coordinates totales del viaje, incluyendo puntos de referencia y assets
        looper: true,
        period: 0,
        times: 0,
        distance: 0,
        timeWill: 0,
        legs: null,
        countLoops: 1,
        rounded: false,
        coordinates: [],
        action: "",
        outsOfTime: 0,
        canExpand: false,
        canReduce: false,
        points: {},
        totals: {...TotalsModel},
        travel: {
            reset: function () {
                this.waypoints = {
                    is: [],
                    items: [],
                };
                this.coordinates = [];
                this.islands = {};
                this.assets = {};
            },
            waypoints: {
                is: [],
                items: [],
            },
            coordinates: [],
            islands: {},
            assets: {},
        },
        assets: {
            in_: [],
            in: [],
            out: [],
            excess: [],
            travel: [],
        },
        tmp: {
            orig: [],
            travel: [],
        },
    };
};
export const PreviewUtils = {
    getTravelFetch: async (coordinates, optimized) => {
        //console.log("[getTravelFetch]", coordinates.length, optimized);
        try {
            //console.log(coordinates);
            const resp = await axiApi.post("/api/distribution/route/travel/", {
                coordinates: coordinates,
                optimized: optimized,
            });

            if (resp.status === 200 && resp?.data?.geojson) {
                return resp.data.geojson;
            }
        } catch (error) {
            console.error("Error al obtener la ruta de Azure:", error);
            throw new Error("Error al calcular la ruta: " + error);
        }
    },
    processRouteData: function (travel) {
        if (!travel || !travel.legs || travel.legs.length === 0) {
            return null;
        }
        const totalDistance = travel.legs.reduce((acc, leg) => acc + leg.distance.value, 0);
        const totalTime = travel.legs.reduce((acc, leg) => acc + leg.duration.value, 0);
        return {totalDistance, totalTime};
    },
};

/*
 * origin: {coord: null, time: 0, id: 0, is_asset: false, lat: null, lng: null},
 * destination: {coord: null, time: 0, id: 0, is_asset: false, lat: null, lng: null},
 * refueling: {coord: null, time: 0, place: "s", id: 0, is_asset: false, lat: null, lng: null},
 * unload: {coord: null, time: 0, place: "s", id: 0, is_asset: false, lat: null, lng: null},
 * */
export const PointsObjectModels = {
    counter: 0,
    origin: null,
    destination: null,
    refueling: null,
    unload: null,
    first: {
        waypoints: [],
        coords: [],
        time: 0,
    },
    last: {
        waypoints: [],
        coords: [],
        time: 0,
    },
    resetPoints: function () {
        this.counter = 0;
        this.first.waypoints = [];
        this.first.coords = [];
        this.first.time = 0;
        this.last.waypoints = [];
        this.last.coords = [];
        this.last.time = 0;
    },
    prepare: async function (formData) {
        this.resetPoints();
        this.origin.type = "point";
        this.origin.is_asset = false;
        this.origin.coord = [this.origin.lng, this.origin.lat];
        this.counter++;
        //
        this.destination.type = "point";
        this.destination.is_asset = false;
        this.destination.coord = [this.destination.lng, this.destination.lat];
        this.counter++;
        //
        this.first.waypoints = [this.origin];
        this.first.coords = [[this.origin.lng, this.origin.lat]];
        //
        this.last.waypoints = [this.destination];
        this.last.coords = [[this.destination.lng, this.destination.lat]];
        // - prepare points to route.
        this.configureRefueling(formData);
        this.configureUnloadPoint(formData);
        // calculate routes add.
        await this.calculateRouteFirst();
        await this.calculateRouteLast();
    },
    configureRefueling: function (formData) {
        if (this.refueling === null) return;
        // -
        this.refueling.type = "point";
        this.refueling.is_asset = false;
        this.refueling.coord = [this.refueling.lng, this.refueling.lat];
        this.refueling.time = formData.params.refueling_time;
        // -
        if (this.refueling.place === "s") {
            this.first.time += this.refueling.time;
            this.first.coords.push([this.refueling.lng, this.refueling.lat]);
            this.first.waypoints.push(this.refueling);
            this.counter++;
        } else if (this.refueling.place === "e") {
            this.last.time += this.refueling.time;
            this.last.coords.unshift([this.refueling.lng, this.refueling.lat]);
            this.last.waypoints.unshift(this.refueling);
            this.counter++;
        } else {
            console.warn("# - Valor de place no reconocido:", this.refueling.place);
            throw new Error("Invalid refueling place: " + this.refueling.place);
        }
    },
    configureUnloadPoint: function (formData) {
        if (this.unload === null) return;
        // -
        this.unload.type = "point";
        this.unload.is_asset = false;
        this.unload.time = formData.params.unload_time;
        this.unload.coord = [this.unload.lng, this.unload.lat];
        // -
        this.last.coords.unshift([this.unload.lng, this.unload.lat]);
        this.last.time += this.unload.time;
        this.last.waypoints.unshift(this.unload);
        this.counter++;
    },
    calculateRouteFirst: async function () {
        if (this.first.coords.length <= 1) return;
        // Calcular ruta desde origen hasta gasolinera
        const routeFirst = await PreviewUtils.getTravelFetch(this.first.coords, false);
        if (routeFirst && routeFirst.legs.length > 0) {
            // Sumar tiempo de recorrido al tiempo de repostaje
            routeFirst.legs.forEach((leg) => {
                this.first.time += Math.ceil(leg.duration / 60);
            });
        } else {
            throw new Error("❌ No se pudo calcular la ruta hasta la gasolinera");
        }
    },
    calculateRouteLast: async function () {
        if (this.last.coords.length <= 1) return;
        // Calcular ruta desde origen hasta gasolinera
        const routeLast = await PreviewUtils.getTravelFetch(this.last.coords, false);
        if (routeLast && routeLast.legs.length > 0) {
            // Sumar tiempo de recorrido al tiempo de repostaje
            routeLast.legs.forEach((leg) => {
                this.last.time += Math.ceil(leg.duration / 60);
            });
        } else {
            throw new Error("❌ No se pudo calcular la ruta hasta la gasolinera");
        }
    },

    getTravelFetch: async (coordinates, optimized) => {
        //console.log("[getTravelFetch]", coordinates.length, optimized);
        try {
            //console.log(coordinates);
            const resp = await axiApi.post("/api/distribution/route/travel/", {
                coordinates: coordinates,
                optimized: optimized,
            });

            if (resp.status === 200 && resp?.data?.geojson) {
                return resp.data.geojson;
            }
        } catch (error) {
            console.error("Error al obtener la ruta de Azure:", error);
            throw new Error("Error al calcular la ruta: " + error);
        }
    },
};
